import {
  ChangeDetectionStrategy,
  Component,
  NgZone,
  WritableSignal,
  inject,
  signal,
} from "@angular/core";
import { TranslocoModule } from "@ngneat/transloco";
import { LineBreaksPipe } from "src/app/core/pipe/line-break.pipe";
import { SvgIconComponent } from "src/app/shared/components/social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-futures-footer",
  templateUrl: "./futures-footer.component.html",
  styleUrl: "./futures-footer.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, LineBreaksPipe, SvgIconComponent],
})
export class FuturesFooterComponent {
  private readonly _ngZone: NgZone = inject(NgZone);

  public readonly textVisible: WritableSignal<boolean> = signal<boolean>(false);
  public readonly currentYear: number = new Date().getFullYear();

  public additionalText(): void {
    this.textVisible.update((visible: boolean): boolean => !visible);

    if (this.textVisible()) {
      this._ngZone.runOutsideAngular((): void => {
        const element: HTMLElement | null = document.getElementById("futuresFooterTarget");
        if (element) {
          setTimeout((): void => {
            element.scrollIntoView({ behavior: "smooth" });
          }, 350);
        }
      });
    }
  }
}
